import { Host, h } from "@stencil/core";
import { FallbackRenderInfo } from "../../utils/FallbackRenderInfo";
export class ApieTestInput {
    constructor() {
        this.renderInfo = new FallbackRenderInfo();
        this.value = 'value';
        this.initialValue = 'value';
        this.type = 'text';
        this.disabled = false;
        this.hasClientValidationError = false;
        this.clientValidationError = false;
        this.hasServersideError = false;
        this.allowsNull = false;
        this.emptyStringAllowed = false;
        this.required = false;
        this.touched = false;
        this.withWrapper = true;
    }
    renderField() {
        const input = {
            valueChanged: (newValue) => { this.value = newValue; },
            name: 'test',
            value: this.value,
            label: 'Test field label',
            disabled: this.disabled,
            validationResult: {
                valid: !this.hasClientValidationError,
                messages: this.clientValidationError ? [
                    {
                        message: 'Client side validation error',
                        valid: !this.hasClientValidationError,
                        serverSide: false
                    }
                ] : []
            },
            serverValidationError: this.hasServersideError ? { '': 'Server side validation error' } : {},
            renderInfo: this.renderInfo,
            currentFieldWrapper: this.withWrapper ? this.renderInfo.createFieldWrapper() : (content) => content,
            additionalSettings: {
                autocompleteUrl: this.type === 'combobox' ? '/pages/dummy.json' : null,
                streamType: 'readAsDataURL',
                options: [{ name: 'Option A', value: 'A' }, { name: 'Option B', value: "B" }],
                dateFormat: 'c',
                imageUrl: 'https://picsum.photos/200/300'
            },
            allowsNull: this.allowsNull,
            emptyStringAllowed: this.emptyStringAllowed,
            required: this.required,
            touched: this.touched,
            onTouched: () => this.touched = true,
        };
        return this.renderInfo.renderSingleInput([this.type], input);
    }
    renderTestField(field, name, label) {
        return (h("div", { style: { display: 'flex', width: "30%" } }, h("div", null, field), h("div", null, h("label", { htmlFor: name }, label))));
    }
    renderTypesField() {
        const options = Array.from(this.renderInfo.getAvailabeInputTypes());
        if (options.length === 0) {
            return h("input", { name: "type", value: this.type, onInput: (ev) => this.type = ev.target.value });
        }
        return h("select", { name: "type", onChange: (ev) => this.type = ev.target.value }, options.map((type) => {
            return h("option", { selected: type === this.type, onClick: () => this.type = type }, type);
        }));
    }
    renderCheckbox(name, label) {
        return this.renderTestField(h("input", { name: name, type: "checkbox", checked: this[name], onInput: (ev) => this[name] = ev.target.checked }), name, label);
    }
    render() {
        return (h(Host, { key: '145445edd48cd45576102d40ff98e48aa3ef468d' }, h("div", { key: '11a2ffca01af0d62a769030f75b0bef9d8f3ffae', style: { display: 'flex', flexDirection: 'column' } }, h("div", { key: '32c2f4213441ae32c73538e7636d48e0efac7cb8', style: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' } }, this.renderTestField(this.renderTypesField(), 'type', 'Field type'), this.renderCheckbox('disabled', 'Field disabled'), this.renderCheckbox('hasServersideError', 'Has server-side validation error'), this.renderCheckbox('hasClientValidationError', 'Has client-side validation error'), this.renderCheckbox('clientValidationError', 'Has friendly validation error check'), this.renderCheckbox('touched', 'Field is touched'), this.renderCheckbox('allowsNull', 'Allows null'), this.renderCheckbox('emptyStringAllowed', 'Empty string allowed'), this.renderCheckbox('required', 'Field is required'), this.renderCheckbox('withWrapper', 'Row rendering'), this.renderTestField(h("textarea", { name: "data", onInput: (ev) => this.value = JSON.parse(ev.target.value) }, JSON.stringify(this.value)), 'data', 'Current value'), this.renderTestField(h("textarea", { name: "initial_data", onInput: (ev) => this.initialValue = JSON.parse(ev.target.value) }, JSON.stringify(this.initialValue)), 'initial_data', 'Initial data')), h("div", { key: 'b8e02c45947bff53105640b9459d18decbb4cfec' }, this.renderField()))));
    }
    static get is() { return "apie-test-input"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-test-input.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-test-input.css"]
        };
    }
    static get properties() {
        return {
            "renderInfo": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "RenderInfo",
                    "resolved": "RenderInfo",
                    "references": {
                        "RenderInfo": {
                            "location": "import",
                            "path": "../../utils/RenderInfo",
                            "id": "src/utils/RenderInfo.tsx::RenderInfo"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "new FallbackRenderInfo()"
            }
        };
    }
    static get states() {
        return {
            "value": {},
            "initialValue": {},
            "type": {},
            "disabled": {},
            "hasClientValidationError": {},
            "clientValidationError": {},
            "hasServersideError": {},
            "allowsNull": {},
            "emptyStringAllowed": {},
            "required": {},
            "touched": {},
            "withWrapper": {}
        };
    }
}
//# sourceMappingURL=apie-test-input.js.map
